import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from '../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultPosition } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/constants';

export var TemplatePieChart: Panel = {
    id: 'pie-chart',
    name: 'Pie Chart - Legacy',
    description: '',
    tags: ['Standard', 'Pie Chart', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_pie_chart',
        children: [
            {
                type: 'pieChart',
                id: '1',
                name: 'Pie Chart',
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                analyticsRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        limit: 10,
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.topicName },
                                INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                                PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                                BENCHMARKING: { dimensionName: 'BRAND_ID' }, //BENCHMARKING_ACCOUNT_ID
                                PAID: { dimensionName: 'accountIds' },
                                ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                                TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                                RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                                STORY_MESSAGE: { dimensionName: 'RDB_DATA_SOURCE' },
                                SPR_TASK: { dimensionName: 'ASSIGNEE_ID' },
                                COMMUNITY: {
                                    source: ListeningDimensions.activity,
                                },
                                SAM: {
                                    source: ListeningDimensions.account,
                                    dimensionName: 'ACCOUNT_ID',
                                },
                                AUDIENCE_ACTIVITY: {
                                    source: ListeningDimensions.account,
                                    dimensionName: 'ACCOUNT_ID',
                                },
                            }),
                        ],
                        sorts: [
                            new Sort({ order: 'DESC', projections: 0 }),
                            new Sort({ order: 'ASC', groupBys: 0 }),
                        ],
                        timePeriods: [{ key: 'last_7_days' }],
                        includeTotal: false,
                    }) as any,
                ],
                position: DefaultPosition,
                label: {
                    titleText: 'Pie Chart',
                    enabled: true,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    legendWrap: true,
                    labelLineSpace: 3,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    smartLegendHeader: true,
                    portrait: {
                        widgetOrientation: 'portrait',
                        zoom: 65,
                        legendWidth: 100,
                        innerRadiusSize: 18,
                        totalValueSize: 40,
                        showCustomLabel: false,
                        showCustomRatio: false,
                        minWedgeRatio: 3,
                        minLabelRatio: 3,
                        diameterPaddingRatio: 0.2,
                        labelRadiusRatio: 0.56,
                        legendValueSize: 35,
                        legendPercentageSize: 35,
                        legendOrientation: 'bottom',
                    },
                },
            },
        ],
    },
};
